export var TNCAcceptanceMethod;
(function (TNCAcceptanceMethod) {
    TNCAcceptanceMethod["ON_PLATFORM"] = "on_platform";
    TNCAcceptanceMethod["OFF_PLATFORM"] = "off_platform";
})(TNCAcceptanceMethod || (TNCAcceptanceMethod = {}));
export const DEFAULT_ORGANIZATION_MEMBERS_LIMIT = 20;
export const DEFAULT_ORGANIZATION_MEMBERS_PAGE = 1;
//# sourceMappingURL=types.js.map